import useUser from '../../../hooks/useUser'
import { InternalUserPermission } from '../../../enum/InternalUserPermission'

export interface TenantPermissions {
    can: (key: InternalUserPermission) => boolean
    /** Gating is inactive until the backend returns the permissions array. */
    enforced: boolean
}

const useTenantPermissions = (): TenantPermissions => {
    const { currentUser } = useUser()

    const perms = currentUser?._internal_user_permissions
    const enforced = Array.isArray(perms)

    const can = (key: InternalUserPermission): boolean =>
        enforced ? (perms as string[]).includes(key) : true

    return { can, enforced }
}

export default useTenantPermissions
